export default {"src":"/_next/static/media/2.d431d69c.svg","height":41,"width":41,"blurWidth":0,"blurHeight":0};